<template>
  <div class="product page-shell">
    <banner
      title="产品中心"
      eyebrow="Product Matrix"
      desc="围绕智慧停车、车牌识别、人行通道、安防路障和云端运营平台，构建可组合、可扩展的智能通行产品体系。"
    />

    <section class="section-wrap product-layout">
      <aside class="category-panel">
        <p class="panel-kicker">CATEGORY</p>
        <h2>产品类别</h2>
        <button
          v-for="(item, index) in categoryList"
          :key="item.id"
          class="category-btn"
          :class="{ active: activeCategory === index }"
          @click="selectCategory(index)"
        >
          <span>{{ displayCategoryName(item, index) }}</span>
          <small>{{ item.catList.length }} 个系列</small>
        </button>
      </aside>

      <main class="product-main">
        <div class="product-main__head">
          <div>
            <p class="section-kicker">SELECTED PRODUCTS</p>
            <h2 class="section-title">{{ activeCategoryName }}</h2>
            <p class="section-desc">选择左侧分类查看对应产品系列，所有图片与型号继续来自现有产品库。</p>
          </div>
          <div class="series-tabs">
            <button
              v-for="(item, index) in currentSeries"
              :key="item.id"
              :class="{ active: activeSeries === index }"
              @click="selectSeries(index)"
            >
              {{ item.catName || "默认系列" }}
            </button>
          </div>
        </div>

        <div v-if="products.length" class="product-grid">
          <article v-for="item in products" :key="item.id + item.name" class="product-card">
            <div class="product-card__image">
              <img v-lazy="productImage(item.img)" :alt="item.name" />
            </div>
            <div class="product-card__body">
              <span>Yufei Intelligent</span>
              <h3>{{ item.name || "宇飞智能产品" }}</h3>
              <p>{{ cleanDescription(item.describe) }}</p>
            </div>
          </article>
        </div>

        <div v-else class="empty-state">
          <h3>当前系列暂无产品</h3>
          <p>请切换其他分类或系列查看现有产品资料。</p>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import sourceObj from "../static/sourseImg";

const categoryNames = ["车牌识别与停车系统", "升降柱与路障系统", "人脸识别通行终端"];

export default {
  name: "Product",
  components: {
    Banner
  },
  data() {
    return {
      categoryList: sourceObj.productObj || [],
      activeCategory: 0,
      activeSeries: 0
    };
  },
  computed: {
    currentCategory() {
      return this.categoryList[this.activeCategory] || {};
    },
    currentSeries() {
      return this.currentCategory.catList || [];
    },
    activeCategoryName() {
      return this.displayCategoryName(this.currentCategory, this.activeCategory);
    },
    products() {
      const series = this.currentSeries[this.activeSeries];
      if (series && series.shopList) return series.shopList;
      return this.currentCategory.shopList || [];
    }
  },
  methods: {
    selectCategory(index) {
      this.activeCategory = index;
      this.activeSeries = 0;
    },
    selectSeries(index) {
      this.activeSeries = index;
    },
    displayCategoryName(item, index) {
      return categoryNames[index] || item.catName || "智慧通行产品";
    },
    productImage(img) {
      return `https://web.wlyk.com/static/yufei/${img}`;
    },
    cleanDescription(value) {
      if (!value) return "适用于智慧停车和智能通行场景，可与云端平台、识别设备和现场控制系统组合部署。";
      return String(value)
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 120);
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  min-height: 100vh;
}

.product-layout {
  padding: 72px 0 90px;
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 28px;
  align-items: start;
}

.category-panel {
  position: sticky;
  top: 96px;
  padding: 24px;
  border-radius: 18px;
  background: linear-gradient(180deg, #fff, #f7fbff);
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
}

.panel-kicker {
  color: #1677ff;
  font-size: 12px;
  font-weight: 900;
}

.category-panel h2 {
  margin: 10px 0 20px;
  color: #071a35;
  font-size: 24px;
}

.category-btn {
  width: 100%;
  padding: 16px;
  margin-top: 12px;
  border: 1px solid rgba(22, 119, 255, 0.12);
  border-radius: 14px;
  text-align: left;
  cursor: pointer;
  color: #314563;
  background: #fff;
  transition: all 0.2s ease;
}

.category-btn span,
.category-btn small {
  display: block;
}

.category-btn span {
  font-size: 15px;
  font-weight: 800;
}

.category-btn small {
  margin-top: 6px;
  color: #7b8da7;
}

.category-btn.active,
.category-btn:hover {
  color: #fff;
  border-color: transparent;
  background: linear-gradient(135deg, #1677ff, #00c2ff);
  box-shadow: 0 14px 34px rgba(22, 119, 255, 0.28);
}

.category-btn.active small,
.category-btn:hover small {
  color: #e5f6ff;
}

.product-main {
  min-width: 0;
}

.product-main__head {
  margin-bottom: 26px;
  padding: 28px;
  border-radius: 18px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(239, 247, 255, 0.96)),
    radial-gradient(circle at 100% 0%, rgba(22, 119, 255, 0.18), transparent 30%);
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
}

.series-tabs {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.series-tabs button {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(22, 119, 255, 0.16);
  border-radius: 99px;
  cursor: pointer;
  color: #43607f;
  background: #fff;
}

.series-tabs button.active,
.series-tabs button:hover {
  color: #1677ff;
  border-color: #1677ff;
  background: #edf6ff;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.product-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 70px rgba(16, 68, 130, 0.14);
}

.product-card__image {
  height: 220px;
  display: grid;
  place-items: center;
  padding: 22px;
  background:
    linear-gradient(135deg, #f4f9ff, #eaf5ff),
    radial-gradient(circle at 70% 20%, rgba(22, 119, 255, 0.16), transparent 28%);
}

.product-card__image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-card__body {
  padding: 22px;
}

.product-card__body span {
  color: #1677ff;
  font-size: 12px;
  font-weight: 900;
}

.product-card__body h3 {
  min-height: 52px;
  margin-top: 10px;
  color: #071a35;
  font-size: 20px;
  line-height: 1.3;
}

.product-card__body p {
  margin-top: 12px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.empty-state {
  padding: 80px 24px;
  border-radius: 18px;
  text-align: center;
  background: #fff;
  box-shadow: 0 18px 50px rgba(16, 68, 130, 0.08);
}

.empty-state h3 {
  color: #071a35;
}

.empty-state p {
  margin-top: 10px;
  color: #64748b;
}

@media (max-width: 980px) {
  .product-layout {
    grid-template-columns: 1fr;
  }

  .category-panel {
    position: relative;
    top: auto;
  }

  .product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .product-layout {
    padding: 54px 0 68px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>
